import { Component, OnInit } from '@angular/core';
import { PackingBoxCreateLabelComponent } from '../../../../views/packing-box/dialog/create-label/create-label.component';
import { PackingBoxCreateLabelService } from '../../../../views/packing-box/dialog/create-label/create-label.service';

@Component({
  standalone: true,
  imports: [PackingBoxCreateLabelComponent],
  // selector: 'normal-label',
  templateUrl: 'normal-label.component.html',
  providers: [PackingBoxCreateLabelService],
})
export class NormalLabelComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
